type SeparatorVariant = 'structural' | 'breadcrumb' | 'inset'

/**
 * Preset weights for the header/toolbar rules. Hierarchy is expressed with a
 * single ink (the divider channel) varied only by height + opacity — never a
 * darker hue or a thicker bar — so the whole header stays on one divider ink.
 *   - structural: a zone change (identity → controls). Loudest.
 *   - breadcrumb: a step within the identity trail (app → client). Medium.
 *   - inset:      a fine break within one control group. Faintest.
 */
const VARIANTS: Record<SeparatorVariant, {height: string; color: string}> = {
  structural: {
    height: '72%',
    color: `rgb(var(--mui-palette-dividerChannel) / 0.22)`,
  },
  breadcrumb: {
    height: '60%',
    color: `rgb(var(--mui-palette-dividerChannel) / 0.14)`,
  },
  inset: {
    height: '44%',
    color: `rgb(var(--mui-palette-dividerChannel) / 0.10)`,
  },
}

type SeparatorProps = {variant?: SeparatorVariant}

export default function Separator({variant = 'breadcrumb'}: SeparatorProps) {
  const preset = VARIANTS[variant]
  return (
    <div
      style={{
        height: preset?.height,
        width: 2,
        borderRadius: 1,
        backgroundColor: preset?.color,
        flexShrink: 0,
      }}
    />
  )
}
